const CrawlDepths = () => {
  return Array.from(Array(15).keys()).map(key => ({
    label: key + 1 === 5 ? `${key + 1} (Default)` : key + 1,
    value: key +1,
  }))
}

export { CrawlDepths }